import React, { useCallback, useEffect, useState } from 'react';
import { format, parseISO } from 'date-fns';

import { Button } from 'react-bootstrap';
import { FaRegEdit } from 'react-icons/fa';

import { useHistory } from 'react-router-dom';
import ContratoCadastro from './ContratoCadastro';
import { useToast } from '../../hooks/toast';

import Loading from '../../components/Loading';

import api from '../../services/api';
import getResponseErrors from '../../utils/getResponseErrors';
import { TIPO_CONTRATO, TIPO_USUARIO } from '../../utils/funcoes';
import { useAuth } from '../../hooks/auth';

interface IContrato {
  ConCodigo: number;
  ConTipo: number;
  ConOrigem: number;
  ConTitulo: string;
  ConDataAlteracao: Date;
  ConDataAlteracaoFormatado: string;
  dataBusca: Date;
}

interface IContratoSelecionado {
  ConTipo: number;
  ConOrigem: number;
}

const Cartao: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.SUPERVISOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const { addToast } = useToast();
  const [contratos, setContratos] = useState<IContrato[]>();
  const [contratoSelecionado, setContratoSelecinado] = useState<
    IContratoSelecionado | undefined
  >(undefined);
  const [dataBusca, setDataBusca] = useState<Date>(new Date());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IContrato[]>(`/contratos`);

        const dadosContratoFormatado = response.data.map(con => {
          return {
            ...con,
            ConDataAlteracaoFormatado: format(
              parseISO(con.ConDataAlteracao.toString()),
              "dd/MM/yyyy 'as' HH:mm",
            ),
            dataBusca,
          };
        });

        setContratos(dadosContratoFormatado);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar dados do contratos',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, [addToast, dataBusca]);

  const handleExibeListagem = useCallback((atualiza: boolean) => {
    setContratoSelecinado(undefined);
    if (atualiza) setDataBusca(new Date());
  }, []);

  return (
    <div className="container mt-2">
      <div className="bg-white border p-2 mb-2">
        {loading && <Loading />}

        {contratos && !contratoSelecionado && (
          <>
            <h3>Modelos de Contratos</h3>
            <table
              className="table table-hover table-sm table-font-small table-bordered"
              style={{ borderWidth: '0px' }}
            >
              <thead>
                <tr className="bg-light text-center">
                  <th style={{ minWidth: '100px' }}>Contrato</th>
                  <th style={{ minWidth: '100px' }}>Ult. Alteração</th>
                  <th style={{ width: '70px' }}>Editar</th>
                </tr>
              </thead>
              <tbody>
                {contratos &&
                  contratos.map(rel => (
                    <tr
                      key={`des-${rel.ConCodigo}`}
                      style={{
                        fontSize: 'Small',
                        height: '30px',
                      }}
                    >
                      <td>{rel.ConTitulo}</td>
                      <td>{rel.ConDataAlteracaoFormatado}</td>
                      <td>
                        <Button
                          type="button"
                          variant="outline-primary"
                          size="sm"
                          className="py-0"
                          title="Editar"
                          onClick={() => {
                            setContratoSelecinado({
                              ConTipo: rel.ConTipo,
                              ConOrigem: rel.ConOrigem,
                            });
                          }}
                        >
                          <FaRegEdit />
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        )}

        {contratoSelecionado?.ConTipo === TIPO_CONTRATO.NOVO_CARTAO && (
          <ContratoCadastro
            handleVoltarLista={dados => handleExibeListagem(dados)}
            tipo="NOVO_CARTAO"
            origem={contratoSelecionado.ConOrigem}
          />
        )}

        {contratoSelecionado?.ConTipo === TIPO_CONTRATO.CANCELA_CARTAO && (
          <ContratoCadastro
            handleVoltarLista={dados => handleExibeListagem(dados)}
            tipo="CANCELA_CARTAO"
            origem={contratoSelecionado.ConOrigem}
          />
        )}

        {contratoSelecionado?.ConTipo === TIPO_CONTRATO.RENOVA_CARTAO && (
          <ContratoCadastro
            handleVoltarLista={dados => handleExibeListagem(dados)}
            tipo="RENOVA_CARTAO"
            origem={contratoSelecionado.ConOrigem}
          />
        )}

        {contratoSelecionado?.ConTipo ===
          TIPO_CONTRATO.CANCELA_CARTAO_SEM_FIDELIDADE && (
          <ContratoCadastro
            handleVoltarLista={dados => handleExibeListagem(dados)}
            tipo="CANCELA_CARTAO_SEM_FIDELIDADE"
            origem={contratoSelecionado.ConOrigem}
          />
        )}

        {contratoSelecionado?.ConTipo === TIPO_CONTRATO.MEDICO && (
          <ContratoCadastro
            handleVoltarLista={dados => handleExibeListagem(dados)}
            tipo="MEDICO"
            origem={contratoSelecionado.ConOrigem}
          />
        )}

        {contratoSelecionado?.ConTipo === TIPO_CONTRATO.TRATAMENTO && (
          <ContratoCadastro
            handleVoltarLista={dados => handleExibeListagem(dados)}
            tipo="TRATAMENTO"
            origem={contratoSelecionado.ConOrigem}
          />
        )}

        {contratoSelecionado?.ConTipo === TIPO_CONTRATO.NOVO_CHIP && (
          <ContratoCadastro
            handleVoltarLista={dados => handleExibeListagem(dados)}
            tipo="NOVO_CHIP"
            origem={contratoSelecionado.ConOrigem}
          />
        )}

        {contratoSelecionado?.ConTipo === TIPO_CONTRATO.CANCELA_CHIP && (
          <ContratoCadastro
            handleVoltarLista={dados => handleExibeListagem(dados)}
            tipo="CANCELA_CHIP"
            origem={contratoSelecionado.ConOrigem}
          />
        )}
      </div>
    </div>
  );
};

export default Cartao;
